import {AbstractControl} from "@angular/forms";
import {Component, Input, ViewChild} from "@angular/core";
import {EmailDataInfoDto} from "../../../models/student-ticket/list-view/EmailDataInfoDto";
import {AbstractFormModalComponent} from "../../../shared/modal/abstract-form-modal.component";
import {ModalShellComponent} from "../../../shared/modal/modal-shell/modal-shell.component";
import {EmailDetailsFormComponent} from "../../../shared/email-details-form/email-details-form.component";

@Component({
  selector: 'app-email-details-adjust-modal',
  templateUrl: './email-details-adjust-modal.component.html',
  styleUrls: ['./email-details-adjust-modal.component.scss'],
  imports: [
    ModalShellComponent,
    EmailDetailsFormComponent
  ],
  standalone: true
})
export class EmailDetailsAdjustModalComponent extends AbstractFormModalComponent {

  @Input() emailDetails: EmailDataInfoDto;

  protected validationErrorKey = 'EMAIL_DATA.VALIDATION_ERROR';

  @ViewChild(EmailDetailsFormComponent) private emailForm: EmailDetailsFormComponent;

  protected get form(): AbstractControl {
    return this.emailForm?.form;
  }

  protected getCloseValue(): unknown {
    return this.emailForm.getFormValue();
  }
}
